import { createSlice } from "@reduxjs/toolkit";

import {
  fetchTournaments,
  fetchTournamentList,
  fetchTournamentById,
  addTournament,
  editTournament,
  removeTournament,
} from "./tournaments.thunk";

const initialState = {
  // Dropdown
  dropdownList: [],
  lastFetched: null,

  // CRUD List
  tournaments: [],
  selectedTournament: null,

  currentPage: 1,
  totalPages: 1,
  total: 0,

  loading: false,
  error: null,
};

const tournamentsSlice = createSlice({
  name: "tournaments",

  initialState,

  reducers: {
    clearTournaments: (state) => {
      state.dropdownList = [];
      state.tournaments = [];
      state.selectedTournament = null;
      state.total = 0;
      state.totalPages = 1;
      state.currentPage = 1;
      state.error = null;
      state.lastFetched = null;
    },

    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setSelectedTournament: (state, action) => {
      state.selectedTournament = action.payload;
    },

    clearSelectedTournament: (state) => {
      state.selectedTournament = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ===========================
         DROPDOWN TOURNAMENTS
      =========================== */

      .addCase(fetchTournaments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchTournaments.fulfilled, (state, action) => {
        state.loading = false;
        state.dropdownList = action.payload || [];
        state.lastFetched = Date.now();
      })

      .addCase(fetchTournaments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===========================
         TOURNAMENT MASTER LIST
      =========================== */

      .addCase(fetchTournamentList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchTournamentList.fulfilled, (state, action) => {
        state.loading = false;

        state.tournaments =
          action.payload?.data || [];

        state.total =
          action.payload?.meta?.total || 0;

        state.totalPages =
          action.payload?.meta?.total_pages || 1;

        state.currentPage =
          action.payload?.meta?.page || 1;
      })

      .addCase(fetchTournamentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===========================
         SINGLE TOURNAMENT
      =========================== */

      .addCase(fetchTournamentById.fulfilled, (state, action) => {
        state.selectedTournament = action.payload;
      })

      /* ===========================
         CREATE
      =========================== */

      .addCase(addTournament.pending, (state) => {
        state.loading = true;
      })

      .addCase(addTournament.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(addTournament.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===========================
         UPDATE
      =========================== */

      .addCase(editTournament.pending, (state) => {
        state.loading = true;
      })

      .addCase(editTournament.fulfilled, (state, action) => {
        state.loading = false;

        const index = state.tournaments.findIndex(
          (item) => item.id === action.payload.id
        );

        if (index !== -1) {
          state.tournaments[index] = {
            ...state.tournaments[index],
            ...action.payload,
          };
        }
      })

      .addCase(editTournament.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===========================
         DELETE
      =========================== */

      .addCase(removeTournament.pending, (state) => {
        state.loading = true;
      })

      .addCase(removeTournament.fulfilled, (state, action) => {
        state.loading = false;

        state.tournaments = state.tournaments.filter(
          (item) => item.id !== action.payload.id
        );

        state.total = Math.max(0, state.total - 1);
      })

      .addCase(removeTournament.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearTournaments,
  setCurrentPage,
  setSelectedTournament,
  clearSelectedTournament,
} = tournamentsSlice.actions;

export default tournamentsSlice.reducer;

// import { createSlice } from "@reduxjs/toolkit";
// import { fetchTournaments } from "./tournaments.thunk";

// /* =============================================================
//    🧩 INITIAL STATE
// ============================================================= */
// const initialState = {
//   list: [],
//   loading: false,
//   error: null,
//   lastFetched: null, // 🔥 for caching
// };

// /* =============================================================
//    🧩 SLICE
// ============================================================= */
// const tournamentsSlice = createSlice({
//   name: "tournaments",
//   initialState,
//   reducers: {
//     clearTournaments: (state) => {
//       state.list = [];
//       state.error = null;
//       state.lastFetched = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchTournaments.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchTournaments.fulfilled, (state, action) => {
//         state.loading = false;
//         state.list = action.payload;
//         state.lastFetched = Date.now();
//       })
//       .addCase(fetchTournaments.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload || action.error.message;
//       });
//   },
// });

// export const { clearTournaments } = tournamentsSlice.actions;

// export default tournamentsSlice.reducer;